import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  FormControl,
  FormControlLabel,
  MenuItem,
  Paper,
  Radio,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import Account from "../../../utils/apiConfig";
import ApiServices from "../../../service/apiService";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";
import { FormattedMessage, useIntl } from "react-intl";
import ErrorHandler from "../../../utils/errorConfig";
import { PerformanceAuditView } from "@mikros/library/src/model";
import Textarea from "@mui/joy/Textarea";
import { PostAuditRatings, UsersAuditViewModel } from "@mikros/library";
import AuthService from "../../../service/authService";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

export interface NewUserAuditProps {
  ref: any;
  employeeDetails?: any;
  auditFormDataFunction?: Function;
  auditFormData?: any;
  onIncompleRatings?: Function;
  auditDialogToggle?: Function;
  auditDialogValue?: boolean;
  dataGridItems?: any;
  submitAudit?: Function;
  userAuditData: UsersAuditViewModel;
  onReload?: Function;
}

export function NewUserAudit(props: NewUserAuditProps) {
  const accountInstance = Account.getInstance();

  const errorInstance = ErrorHandler.getErrorInstance();
  const intl = useIntl();
  const navigate = useNavigate();

  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const [sub, setSub] = useState(null);
  const subRef = useRef(null);

  const [obtainedMarks, setObtainedMarks] = useState<any>();
  const [comments, setComments] = useState<string>("");
  const [submitClicked, setSubmitClicked] = useState(false);

  const [auditFormData, setAuditFormData] = useState({
    ratings: [],
    comments: " ",
    obtainedMarks: 0,
  });

  const [auditName, setAuditName] = useState<string>("");

  const [auditList, setAuditList] = useState<any>("");

  console.log("audit name print", auditName);
  console.log("print audit list", auditList);
  console.log("user name in new user audit ", auditList.userName);

  const handleChangeAuditName = (event: { target: { value: any } }) => {
    setAuditName(event.target.value);
    setRowRatings(initialRatingsObject);
  };

  const [auditData, setAuditData] = useState<PerformanceAuditView>({
    auditName: "",
    auditId: "",
    auditQuestions: [],
    recType: "",
    updatedAt: "",
    entityId: "",
    createdAt: "",
    latestQuestions: "",
  });
  const [postAudit, setPostAudit] = useState<PostAuditRatings>({
    auditResponse: [],
    accntId: "",
    auditedBy: "",
    auditDate: "",
    auditId: "",
    auditName: "",
    maxScore: 0,
    actualScore: 0,
    comments: "",
    userId: "",
  });

  const [rateCount, setRateCount] = useState<number>(0);
  const [ratingsAlert, setRatingsAlert] = useState<boolean>(false);
  const [successAuditDialog, setSuccessAuditDialog] = useState<boolean>(false);

  console.log(
    "user audit details in performance audit print please",
    props.userAuditData
  );
  const numberOfQuestions = auditData?.auditQuestions?.length;
  const initialRatings: Record<number, number> = Object?.fromEntries(
    Array.from({ length: numberOfQuestions }, (_, i) => [i + 1, 0])
  );
  console.log("rate count value", rateCount);

  const handleCommentsMessage = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setComments(e.target.value);
  };

  const initialRatingsObject = Object.keys(initialRatings).reduce(
    (acc: Record<number, number>, key) => {
      const numericKey = Number(key); //convert key to a number
      acc[numericKey] = initialRatings[numericKey];
      return acc;
    },
    {} as Record<number, number>
  );
  const ratingMapping: Record<string, number> = {
    [intl.formatMessage({ id: "users.performanceAudit.ratings.excellent" })]: 5,
    [intl.formatMessage({ id: "users.performanceAudit.ratings.good" })]: 4,
    [intl.formatMessage({ id: "users.performanceAudit.ratings.average" })]: 3,
    [intl.formatMessage({ id: "users.performanceAudit.ratings.poor" })]: 2,
    [intl.formatMessage({ id: "users.performanceAudit.ratings.veryPoor" })]: 1,
  };

  const [rowRatings, setRowRatings] = useState<any>(initialRatingsObject);

  const totMarks = numberOfQuestions * 5;

  console.log(
    "audit data print in performance audit adfadsfasassad",
    auditData
  );
  console.log("number of questions", numberOfQuestions);
  console.log("initial ratings", initialRatings);
  console.log("obtained marks afssfddsaffsd", obtainedMarks);
  console.log("row ratings on render", rowRatings);

  type Status = "ACTIVE" | "INACTIVE" | "";
  const statusMapping: { [key in Status]: string } = {
    ACTIVE: "enabled",
    "": "enabled",
    INACTIVE: "disabled",
  };

  console.log("audit form data outside in audit view", auditFormData);
  console.log("props data grid items values", props.dataGridItems);

  console.log("print the available comments", props.auditFormData?.comments);

  console.log("audit data print", auditData);
  console.log("audit data questions", auditData?.auditQuestions);

  console.log("employee details print", props?.employeeDetails);

  const handleIncompleteRatings = () => {
    console.log(
      "Not all ratings are complete. Please ensure all ratings are provided."
    );
    toggleRatingsAlertDialog();
  };
  const toggleRatingsAlertDialog = () => {
    setRatingsAlert(!ratingsAlert);
  };
  const toggleSuccessAuditDialog = () => {
    setSuccessAuditDialog(!successAuditDialog);
  };

  const prepareAuditData = async () => {
    setSubmitClicked(true);
    await handleOnSubmit();
  };

  const handleOnSubmit = async () => {
    if (rateCount === numberOfQuestions) {
      console.log(
        "entered rate count equals to number of questions in handle view submit"
      );

      try {
        let preparedAuditData = postAudit;
        postAudit.accntId = accountInstance.accntId;
        postAudit.actualScore = obtainedMarks;
        postAudit.auditName = auditName;
        postAudit.maxScore = totMarks;
        postAudit.comments = comments;
        postAudit.auditId = auditData.auditId;
        postAudit.userId = props.employeeDetails.userId;
        postAudit.auditedBy = auditList.userName;
        postAudit.auditDate = new Date().toISOString();
        postAudit.auditResponse = auditData.auditQuestions.map(
          (question, index) => ({
            Q: question.Q,
            C: question.C,
            R: rowRatings[index + 1] || 0,
          })
        );
        console.log("post audit body", postAudit);
        let api = ApiServices.getInstance();
        if (accountInstance.accntId) {
          api
            .makeRequest(
              `${accountInstance.accntId}/useraudit`,
              "POST",
              preparedAuditData
            )
            .then(async (response) => {
              if (response && response.errorMessage) {
                console.log("inside new user audit");
                setErrorFlag(true);
                await errorInstance.updateErrorCode(response.errorMessage);
                return;
              } else {
                console.log("audit data successfully updated", response);
                toggleSuccessAuditDialog();
              }
            });
        }
      } catch (error) {
        console.error("Error submitting audit data", error);
      }
    } else if (rateCount !== numberOfQuestions) {
      handleIncompleteRatings();
    }
  };

  const handleRatingChange = (slNo: any, newRating: any) => {
    setRowRatings((prev: any) => {
      const updatedRatings = { ...prev, [slNo]: newRating };
      const totalMarks = Object.values(updatedRatings).reduce(
        (acc: any, curr: any) => acc + curr,
        0
      );
      console.log(
        "row ratings values inside handle rating change",
        updatedRatings
      );
      const updatedRatingsCount = Object.values(updatedRatings).filter(
        (value: any) => value > 0
      ).length;
      console.log(
        "updated ratings count inside handle rating change",
        updatedRatingsCount
      );
      setObtainedMarks(totalMarks);
      return updatedRatings;
    });
  };
  const getBarColor = () => {
    console.log("obtained marks in get bar color", obtainedMarks);
    console.log("total marks in get bar color", totMarks);
    if (obtainedMarks < totMarks * 0.45) {
      console.log("inside obtained marks less than 45%");
      return "bg-red-500";
    } else if (
      (console.log("inside obtained marks between 45% and 67%"),
      (obtainedMarks >= totMarks * 0.45 && obtainedMarks < totMarks * 0.67) ||
        (obtainedMarks >= totMarks * 0.67 && obtainedMarks < totMarks * 0.78))
    ) {
      return "bg-yellow-500";
    } else if (obtainedMarks >= totMarks * 0.78) {
      console.log("inside obtained marks greater than 78%");
      return "bg-green-500";
    }
  };
  console.log("sub ref current val", subRef.current);

  useEffect(() => {
    async function fetchSub() {
      let a = await AuthService.getInstance().getIdToken();
      console.log("id token course", a);
      const decoded: any = jwtDecode(a);
      const subValue = decoded["sub"];
      setSub(subValue);
      subRef.current = subValue;
      console.log("print tenant id inside use effect", subValue);
    }
    fetchSub();
  }, []);

  useEffect(() => {
    if (auditName !== "") {
      console.log("I enterd use effect for audit name");
      const initialMarks = Object.values(initialRatingsObject).reduce(
        (acc, curr) => acc + curr,
        0
      );
      setObtainedMarks(initialMarks);
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            `${accountInstance.accntId}/audit?auditName=${auditName}`,
            "GET"
          )
          .then(async (data) => {
            if (data && data.errorMessage) {
              console.log("entered error code handling in audit");
              setErrorFlag(true);
              await errorInstance.updateErrorCode(data.errorMessage);
            } else {
              setAuditData(data);
            }
          });
      }
    }
  }, [auditName]);

  useEffect(() => {
    if (subRef.current !== null) {
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            `${accountInstance.accntId}/audit/auditnames?userId=${subRef.current}`,
            "GET"
          )
          .then(async (data) => {
            if (data && data.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(data.errorMessage);
            } else {
              setAuditList(data);
            }
          });
      }
    }
  }, [subRef.current]);

  React.useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  useEffect(() => {
    const ratingsCount = Object.values(rowRatings).filter(
      (value: any) => value > 0
    ).length;
    console.log(
      "ratings count in use effect for prepare audit data",
      ratingsCount
    );
    setRateCount(ratingsCount);
    setAuditFormData({
      ratings: rowRatings,
      comments: comments,
      obtainedMarks: obtainedMarks,
    });
  }, [rowRatings]);

  return (
    <div className="w-full">
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                // navigate("/home");
                navigate("/home");
              } else {
                navigate("/audit");
              }
            }}
          />
        </Dialog>
      )}
      {ratingsAlert && (
        <Dialog className="alertDialogue">
          <Alert
            description={intl.formatMessage({
              id: "users.auditView.ratingsAlert",
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"alertShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgAlert" })}
            backgroundColor={"mk-orange"}
            onClick={() => {
              toggleRatingsAlertDialog();
            }}
          />
        </Dialog>
      )}
      {successAuditDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "users.auditView.auditDetailSuccess",
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"successShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgSuccess",
            })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleSuccessAuditDialog();
              if (props.auditDialogToggle) {
                props.auditDialogToggle(!props.auditDialogValue);
              }
              if (props.onReload) {
                props.onReload();
              }
            }}
          />
        </Dialog>
      )}

      <div className="flex justify-between items-center mt-2">
        <div className="text-mk-primary-bright text-2xl font-bold ml-4">
          <FormattedMessage id="users.performanceAudit.evaluationReport" />
        </div>
        <div
          onClick={() => {
            if (props.auditDialogToggle) {
              props.auditDialogToggle(!props.auditDialogValue);
            }
          }}
          className="pt-1 pb-1 pl-2 pr-2 rounded-full hover:cursor-pointer bg-mk-primary-50 mr-4"
        >
          <FontAwesomeIcon
            icon={["far", "fa-xmark" as IconName]}
            className="w-3 h-3"
          />
        </div>
      </div>
      <div className="mt-6"></div>
      <div className="grid grid-cols-3 gap-4 text-base items-center w-full ml-4 mr-4">
        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="users.auditView.employeeName" />:
          </div>
          <div>{props.employeeDetails.employeeName}</div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="users.performanceAudit.branch" />:
          </div>
          <div>{props.employeeDetails.branchName}</div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="users.performanceAudit.obtainedMarks" />:
          </div>
          <div>{obtainedMarks}</div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="users.performanceAudit.auditName" />:
          </div>

          <FormControl margin="dense" sx={{ width: "16rem" }}>
            <Select
              value={auditName}
              onChange={handleChangeAuditName}
              displayEmpty
              renderValue={(selected) =>
                selected
                  ? selected
                  : intl.formatMessage({
                      id: "audit.createAuditQuestion.selectauditName",
                    })
              }
            >
              {Array.isArray(auditList?.result) &&
                auditList?.result?.map((audit: any) => (
                  <MenuItem key={audit?.auditName} value={audit?.auditName}>
                    {audit?.auditName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="users.performanceAudit.totalMarks" />:
          </div>
          <div>{totMarks}</div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="users.performanceAudit.overallPerformance" />:
          </div>
          <div className={`h-4 w-36 ${getBarColor()}`}></div>
        </div>
      </div>

      <div className="flex mt-6 w-full">
        <div
          className="text-mk-primary-bright w-full"
          style={{ marginRight: "1rem", marginLeft: "1rem" }}
        >
          <TableContainer
            component={Paper}
            elevation={0}
            className="noOutline w-full"
            style={{
              width: "100%",
            }}
          >
            <Table
              size="small"
              className="w-full bg-mk-white"
              sx={{
                "&:hover": {
                  backgroundColor: "#FFF !important", // Sets the background color to white on hover
                },
                "& td, & th": {
                  padding: "0 !important",
                },
              }}
            >
              <TableHead
                sx={{
                  backgroundColor: "transparent !important",
                  // "&:hover": {
                  //   backgroundColor: "transparent !important",
                  // },
                  "& .MuiTableRow-root:hover": {
                    background: "var(--color-mk-white) !important",
                  },
                  "&:hover": {
                    backgroundColor: "var(--color-mk-white) !important",
                  },
                }}
              >
                <TableRow
                  sx={{
                    "&:hover": {
                      backgroundColor: "transparent !important", // Sets the background color to white on hover
                    },
                  }}
                >
                  <TableCell
                    // className="auditCustom-header w-[5%]"
                    style={{
                      width: "5%",
                      whiteSpace: "nowrap",
                      padding: 0,
                    }}
                  >
                    <FormattedMessage id="slNo" />
                  </TableCell>
                  <TableCell
                    // className="auditCustom-header w-[25%]"
                    style={{
                      width: "20%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: 0,
                    }}
                  >
                    <FormattedMessage id="users.auditView.checklist" />
                  </TableCell>
                  <TableCell
                    // className="auditCustom-header w-[40%]"
                    style={{
                      width: "40%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: 0,
                    }}
                  >
                    <FormattedMessage id="users.auditView.rating" />
                  </TableCell>
                  <TableCell
                    //  className="auditCustom-header w-[30%]"
                    style={{
                      width: "35%",
                      whiteSpace: "normal",
                      // wordBreak: "break-word",
                      padding: 0,
                    }}
                  >
                    <FormattedMessage id="users.auditView.assessmentCriteria" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                sx={{
                  "&:hover": {
                    backgroundColor: "#FFF !important", // Sets the background color to white on hover
                  },
                }}
              >
                {auditName !== "" ? (
                  auditData?.auditQuestions?.map((detail, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        border: "none",
                        backgroundColor: "mk-white",
                        "&:hover": {
                          backgroundColor: "#FFF !important", // Sets the background color to white on hover
                        },
                      }}
                    >
                      <TableCell
                      // className="audit-custom-column1"
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                      // className="audit-custom-column2"
                      >
                        {detail.Q}
                      </TableCell>
                      <TableCell
                      // className="audit-custom-column3"
                      >
                        <div className="flex space-x-1">
                          {Object.entries(ratingMapping).map(
                            ([label, value]) => (
                              <FormControlLabel
                                key={value}
                                control={
                                  <Radio
                                    disableRipple
                                    size="small"
                                    checked={rowRatings[index + 1] === value}
                                    onChange={() =>
                                      handleRatingChange(index + 1, value)
                                    }
                                    value={value}
                                    className="auditCustom-header"
                                  />
                                }
                                label={
                                  <span style={{ fontSize: "0.875rem" }}>
                                    {label}
                                  </span>
                                }
                                sx={{ marginRight: 0, gap: "2px" }}
                              />
                            )
                          )}
                        </div>
                      </TableCell>

                      {/* <TableCell className="audit-custom-column4">
                        {detail.C}
                      </TableCell> */}

                      <TableCell
                      // className="audit-custom-column4"
                      >
                        {(Array.isArray(detail.C)
                          ? detail.C
                          : String(detail.C).split(",")
                        ).map((criteria, index) => (
                          // <React.Fragment key={index}>
                          //   {criteria.trim()}
                          //   <br />
                          // </React.Fragment>

                          <div
                            key={index}
                            style={{ marginBottom: "4px", lineHeight: "1.4" }} // adjust spacing here
                          >
                            {criteria.trim()}
                          </div>
                        ))}
                      </TableCell>
                    </TableRow>
                  )) || (
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        className="text-center"
                      ></TableCell>
                    </TableRow>
                  )
                ) : (
                  <TableCell colSpan={4} align="center">
                    <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                      <FormattedMessage id="audit.newUserAudit.selectAuditNameDropdown" />
                    </div>
                  </TableCell>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      <div className="mt-6"></div>
      <div className="p-2 ml-4 mr-4">
        <div className="font-bold w-full">
          <FormattedMessage id="users.auditView.essentialPoints" />
        </div>
        <div className="pt-2">
          <Textarea
            minRows={5}
            maxRows={5}
            value={comments}
            onChange={handleCommentsMessage}
            sx={{
              backgroundColor: "var(--color-mk-white)",
              border: "1px solid #E1E2E9",
              "&::before, &::after": {
                display: "none !important", // Removes default Joy UI focus styles
              },
              "&:focus-within": {
                border: "2px solid var(--color-mk-primary)", // Custom focus border color (change as needed)
              },
            }}
          />
        </div>
      </div>

      <div className="flex justify-end gap-4 pt-3 mr-4">
        <Button
          type="submit"
          variant="contained"
          disableRipple
          sx={{
            mt: 2,
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "white",

            backgroundColor: "#6464E5",
            "&:hover": {
              backgroundColor: "#E1E2E9",
              color: "black",
            },
            display: "inline-block",
          }}
          onClick={prepareAuditData}
          disabled={auditName === ""}
        >
          <FormattedMessage id="saveButton" />
        </Button>
        <Button
          type="button" // Use 'button' type to prevent form submission
          variant="contained"
          disableRipple // Disable ripple effect
          sx={{
            mt: 2,
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "black",

            backgroundColor: "#E1E2E9",
            "&:hover": {
              backgroundColor: "#E1E2E9",
            },

            display: "inline-block",
          }}
          onClick={() => {
            if (props.auditDialogToggle) {
              props.auditDialogToggle(!props.auditDialogValue);
            }
          }}
        >
          <FormattedMessage id="cancelButton" />
        </Button>
      </div>
    </div>
  );
}
